<template>
  <div>
    <loading
      :active.sync="loading_content"
      :can-cancel="false"
      :is-full-page="true"
      :color="'#0B8BCC'"
      :loader="'dots'"
      :opacity="0.7"
      :lock-scroll="true"
    ></loading>
    <div id="appCapsule">
      <div class="pt-2 pb-2 pl-3 pr-3">
        <div class="center">
          <div class="card" v-if="feedback_available == 'AVAILABLE'">
            <div class="card-body text-center">
              <h3>Ulasan Percakapan</h3>
              <div class="form-group mt-3 mb-0">
                <div class="rating">
                  <input
                    type="radio"
                    id="star5"
                    name="rating"
                    value="5"
                    v-model="feedback_data.rating"
                  /><label for="star5"></label>
                  <input
                    type="radio"
                    id="star4"
                    name="rating"
                    value="4"
                    v-model="feedback_data.rating"
                  /><label for="star4"></label>
                  <input
                    type="radio"
                    id="star3"
                    name="rating"
                    value="3"
                    v-model="feedback_data.rating"
                  /><label for="star3"></label>
                  <input
                    type="radio"
                    id="star2"
                    name="rating"
                    value="2"
                    v-model="feedback_data.rating"
                  /><label for="star2"></label>
                  <input
                    type="radio"
                    id="star1"
                    name="rating"
                    value="1"
                    v-model="feedback_data.rating"
                  /><label for="star1"></label>
                </div>
              </div>
              <div class="form-group">
                <span v-if="feedback_data.rating == 1"
                  ><i class="far fa-tired"></i> Sangat Tidak Baik</span
                >
                <span v-else-if="feedback_data.rating == 2"
                  ><i class="far fa-tired"></i> Tidak Baik</span
                >
                <span v-else-if="feedback_data.rating == 3"
                  ><i class="far fa-meh"></i> Biasa</span
                >
                <span v-else-if="feedback_data.rating == 4"
                  ><i class="far fa-smile"></i> Baik</span
                >
                <span v-else-if="feedback_data.rating == 5"
                  ><i class="far fa-grin-hearts"></i> Sangat Baik</span
                >
              </div>
              <div class="form-group">
                <textarea
                  class="form-control"
                  id="review"
                  rows="3"
                  placeholder="Tuliskan ulasan untuk percakapan ini"
                  style="font-size: 13px;resize: none;"
                  v-model="feedback_data.feedback"
                ></textarea>
              </div>
              <ButtonLoader
                :loading="loading_button"
                :styled="'btn btn-primary btn-block'"
                @click.native="submitFeedback()"
                :disabled="feedback_data.rating == ''"
                >Kirim</ButtonLoader
              >
            </div>
          </div>
          <div class="card" v-else-if="feedback_available == 'DONE'">
            <div class="card-body text-center mt-3 mb-3">
              <img width="30%" :src="require('@/assets/feedback.png')" />
              <h4 class="text-primary mt-3" style="font-weight:bold ;">
                Terima kasih atas ulasan anda!
              </h4>
            </div>
          </div>
          <div
            class="text-center"
            v-else-if="feedback_available == 'UNAVAILABLE'"
          >
            Link Sudah digunakan atau Sudah Kadaluarsa!
          </div>

          <div
            class="section text-center mt-3"
            v-if="
              feedback_available == 'AVAILABLE' || feedback_available == 'DONE'
            "
          >
            <img
              class="w-25"
              :src="require('@/assets/image/logo_header_color.png')"
            />
            <p style="font-size:13px;line-height:normal;">
              [ ] Dengan
              <ion-icon name="heart" style="color:#f24141;"></ion-icon> di
              Indonesia
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $axios from "./../../api.js";
export default {
  data() {
    return {
      loading_content: true,
      loading_button: false,
      feedback_available: "",
      feedback_data: {
        rating: "",
        feedback: "",
      },
    };
  },
  created() {
    this.checkTokenFeedback();
  },
  methods: {
    checkTokenFeedback() {
      this.loading_content = true;
      $axios
        .get("/feedback/check/" + this.$route.params.token)
        .then(() => {
          this.loading_content = false;
          this.feedback_available = "AVAILABLE";
        })
        .catch(() => {
          this.loading_content = false;
          this.feedback_available = "UNAVAILABLE";
        });
    },
    submitFeedback() {
      this.loading_button = true;
      $axios
        .post("/feedback/submit/" + this.$route.params.token, {
          rating: this.feedback_data.rating,
          feedback: this.feedback_data.feedback,
        })
        .then(() => {
          this.feedback_available = "DONE";
          this.loading_button = false;
        })
        .catch(() => {
          this.loading_button = false;
        });
    },
  },
  mounted() {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css";
    document.head.appendChild(link);

    document.body.style.backgroundColor = "#e5e7eb";
  },
  destroyed() {
    // document.body.classList.add("bg-white");
  },
};
</script>
<style>
.rating {
  unicode-bidi: bidi-override;
  direction: rtl;
  display: inline-block;
}
.rating > label {
  display: inline-block;
  padding: 5px;
  font-size: 30px;
}
.rating input {
  display: none;
}
.rating > label:before {
  content: "\f005";
  font-family: "Font Awesome 5 Free";
  margin-right: 5px;
  color: #ffc107;
  cursor: pointer;
}
.rating input:checked ~ label:before {
  font-weight: 900;
  color: #ffc107; /* Warna kuning */
}
</style>
